<template>
  <div class="CreateOrder wide-container">
    <!-- 1. 顶部流程进度指示条 (强化企业采购闭环仪式感) -->
    <div class="order-step-bar">
      <div class="step-item is-finish">
        <span class="step-num"><i class="el-icon-check"></i></span>
        <span class="step-title">选购与清单</span>
      </div>
      <div class="step-line is-finish"></div>
      <div class="step-item is-active">
        <span class="step-num">2</span>
        <span class="step-title">确认订单与核对</span>
      </div>
      <div class="step-line"></div>
      <div class="step-item">
        <span class="step-num">3</span>
        <span class="step-title">提交审核与履约</span>
      </div>
    </div>

    <!-- 2. 收货地址选择卡片面板 -->
    <div class="section-card address-section">
      <div class="section-header">
        <div class="header-left">
          <span class="accent-bar"></span>
          <h2 class="section-title">选择收货地址</h2>
          <span class="section-sub">请核对采购物料的精准企业收货地址与联系人</span>
        </div>
        <button class="add-address-btn" @click="showDialogVisible" type="button">
          <i class="el-icon-plus"></i> 新增收货地址
        </button>
      </div>

      <!-- 地址卡片网格 -->
      <div class="address-grid">
        <div
          v-for="(item, index) in addressList"
          :key="item.id || index"
          class="address-card"
          :class="{ 'is-selected': id === item.id }"
          @click="changeAddress(item)"
        >
          <!-- 选中标志角标 -->
          <div class="selected-corner" v-if="id === item.id">
            <i class="el-icon-check"></i>
          </div>

          <div class="card-top">
            <span class="receiver-name">{{ item.mdbcej4opshigmrs }}</span>
            <span class="badge-empid" v-if="item['3ulvzh2pgygl0vga']">工号: {{ item['3ulvzh2pgygl0vga'] }}</span>
          </div>

          <div class="card-detail-item">
            <i class="el-icon-mobile-phone item-icon"></i>
            <span>{{ item.xejhteu0ub3fd3eh }}</span>
          </div>

          <div class="card-detail-item addr-text">
            <i class="el-icon-location-outline item-icon"></i>
            <span>
              {{ (item.b3ccmzbfyzlwy9sc && item.b3ccmzbfyzlwy9sc.map((el) => el.value).join('')) || '' }}
              {{ item['9simp0sjii9s0m33'] || '' }}
            </span>
          </div>
        </div>

        <!-- 快速新增地址卡片 -->
        <div class="address-card add-card" @click="showDialogVisible">
          <div class="add-inner">
            <div class="add-icon-circle">
              <i class="el-icon-plus"></i>
            </div>
            <span class="add-text">添加新地址</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. 商品清单明细面板 (100% 兼容 3 种来路数据) -->
    <div class="section-card goods-section">
      <div class="section-header">
        <div class="header-left">
          <span class="accent-bar"></span>
          <h2 class="section-title">物料清单明细</h2>
          <span class="section-sub">共 {{ commodityList.length }} 项物资，请核对名称、单价与订购数量</span>
        </div>
        <div class="header-right">
          <span class="contract-tax-tag">
            <i class="el-icon-document-checked"></i> 含 13% 增值税专用发票随货同行
          </span>
        </div>
      </div>

      <!-- 表头规范化 -->
      <div class="goods-table-header">
        <div class="col-info">物资信息与规格</div>
        <div class="col-price">协议单价</div>
        <div class="col-unit">计量单位</div>
        <div class="col-qty">采购数量</div>
        <div class="col-total">小计金额</div>
      </div>

      <!-- 商品行列表 -->
      <ul class="goods-row-list">
        <li v-for="item in commodityList" :key="'order-' + item.id" class="goods-table-row">
          <!-- 1. 购物车来路 (form === 'cart') -->
          <template v-if="form === 'cart'">
            <div class="col-info">
              <div class="thumb-wrap">
                <img
                  :src="
                    item['gdlu2l0z6a7sprky'] && item['gdlu2l0z6a7sprky'].length > 0
                      ? item['gdlu2l0z6a7sprky'][0].url
                      : ''
                  "
                  alt="商品图"
                  class="thumb-img"
                />
              </div>
              <div class="meta-info">
                <p class="name-text" :title="item['duovdnoapszqxeih'] && item['duovdnoapszqxeih'][0].value">
                  {{ item['duovdnoapszqxeih'] && item['duovdnoapszqxeih'][0].value }}
                </p>
                <span class="sku-code font-mono" v-if="item.tygpzkobrzzhltwd">SKU: {{ item.tygpzkobrzzhltwd }}</span>
              </div>
            </div>
            <div class="col-price font-mono">
              ¥ {{ formatMoney(item.qajsmihzqxevgihj) }}
            </div>
            <div class="col-unit">
              {{ item.ycqgzdztcyhqnczy || '件' }}
            </div>
            <div class="col-qty font-mono">
              {{ item.tbdn8rpen3ijbiv2 }}
            </div>
            <div class="col-total font-mono">
              ¥ {{ formatMoney(item.tbdn8rpen3ijbiv2 * item.qajsmihzqxevgihj) }}
            </div>
          </template>

          <!-- 2. 常购清单来路 (form === 'regularPurchaseList') -->
          <template v-else-if="form === 'regularPurchaseList'">
            <div class="col-info">
              <div class="thumb-wrap">
                <img
                  :src="
                    item['mnkt8dkjryhvdej3'] && item['mnkt8dkjryhvdej3'].length > 0
                      ? item['mnkt8dkjryhvdej3'][0].url
                      : ''
                  "
                  alt="商品图"
                  class="thumb-img"
                />
              </div>
              <div class="meta-info">
                <p class="name-text" :title="item['whfmbyuc1i2pavi4'] && item['whfmbyuc1i2pavi4'][0].value">
                  {{ item['whfmbyuc1i2pavi4'] && item['whfmbyuc1i2pavi4'][0].value }}
                </p>
                <span class="sku-code font-mono" v-if="item.p21recpjamiavinh">SKU: {{ item.p21recpjamiavinh }}</span>
              </div>
            </div>
            <div class="col-price font-mono">
              ¥ {{ formatMoney(item.t9rtdu9o7iztvayy) }}
            </div>
            <div class="col-unit">
              {{ item.kq1qbbk7dulmlghs || '件' }}
            </div>
            <div class="col-qty font-mono">
              {{ item.mcuilzaudpe3shlc || 1 }}
            </div>
            <div class="col-total font-mono">
              ¥ {{ formatMoney(item.t9rtdu9o7iztvayy * (item.mcuilzaudpe3shlc || 1)) }}
            </div>
          </template>

          <!-- 3. 商品详情直接购买来路 (默认 detail) -->
          <template v-else>
            <div class="col-info">
              <div class="thumb-wrap">
                <img
                  :src="
                    item['in7kxcfnzrfwav2r'] && item['in7kxcfnzrfwav2r'].length > 0
                      ? item['in7kxcfnzrfwav2r'][0].url
                      : ''
                  "
                  alt="商品图"
                  class="thumb-img"
                />
              </div>
              <div class="meta-info">
                <p class="name-text" :title="item['6qujfllbbkwsj6t1'] && item['6qujfllbbkwsj6t1'][0].value">
                  {{ item['6qujfllbbkwsj6t1'] && item['6qujfllbbkwsj6t1'][0].value }}
                </p>
                <span class="sku-code font-mono" v-if="item.levmoblohezp7y50">SKU: {{ item.levmoblohezp7y50 }}</span>
              </div>
            </div>
            <div class="col-price font-mono">
              ¥ {{ formatMoney(item.f93blbqlvdtdt65v) }}
            </div>
            <div class="col-unit">
              {{ item.y8cegh2yyvvqbzwo || '件' }}
            </div>
            <div class="col-qty font-mono">
              {{ number }}
            </div>
            <div class="col-total font-mono">
              ¥ {{ formatMoney(number * item.f93blbqlvdtdt65v) }}
            </div>
          </template>
        </li>
      </ul>
    </div>

    <!-- 4. 客户备注与结算汇总看板 -->
    <div class="settle-dashboard-layout">
      <!-- 左侧：客户备注 -->
      <div class="section-card remark-card">
        <div class="section-header">
          <div class="header-left">
            <span class="accent-bar"></span>
            <h2 class="section-title">采购审批备注 / 配送说明</h2>
          </div>
        </div>
        <el-input
          type="textarea"
          placeholder="可在此填写部门审批编号、项目对账代号或特殊的入库配送要求（选填）..."
          v-model="remark"
          :autosize="{ minRows: 3, maxRows: 5 }"
          class="remark-textarea"
        >
        </el-input>
        <div class="remark-tips">
          <i class="el-icon-info"></i> 该备注将自动同步至订单详情与财务月结对账单中。
        </div>
      </div>

      <!-- 右侧：金额汇总与支付决策面板 -->
      <div class="section-card summary-card">
        <div class="summary-lines">
          <div class="summary-row">
            <span class="label">物资品种数：</span>
            <span class="val font-mono">{{ commodityList.length }} 种</span>
          </div>
          <div class="summary-row">
            <span class="label">开票类型：</span>
            <span class="val">13% 增值税专用发票</span>
          </div>
          <div class="summary-row">
            <span class="label">物流运费：</span>
            <span class="val free-tag">协议免邮 (专线直达)</span>
          </div>
          <div class="summary-divider"></div>
          <div class="summary-row total-row">
            <span class="total-label">应付总金额：</span>
            <div class="total-amount-box">
              <span class="currency">¥</span>
              <span class="total-amount font-mono">{{ formatMoney(pay_amount) }}</span>
            </div>
          </div>
        </div>

        <div class="action-buttons-wrap">
          <!-- 微信支付按钮 -->
          <button class="pay-btn wechat-btn" @click="handleWechatPay" type="button">
            <i class="el-icon-chat-dot-round"></i>
            <span>微信支付</span>
          </button>
          <!-- 提交订单 (企业月结通道) -->
          <button class="pay-btn submit-btn" @click="createAnOrder" type="button">
            <span>提交订单</span>
            <i class="el-icon-right"></i>
          </button>
        </div>
        <p class="safe-promise-text">
          <i class="el-icon-shield"></i> 支持企业对公月结自动核账 · 资金与交易安全受协议保护
        </p>
      </div>
    </div>

    <!-- 5. 新增收货地址弹窗 (深蓝规范定制，100% 保持原有字段) -->
    <el-dialog
      title="新增企业收货地址"
      :visible.sync="dialogVisible"
      width="500px"
      :show-close="true"
      :close-on-click-modal="false"
      class="address-dialog"
    >
      <el-form ref="form" :model="address" label-width="86px" class="dialog-form">
        <el-form-item label="员工工号" required>
          <el-input
            v-model="address['3ulvzh2pgygl0vga']"
            placeholder="请输入员工工号（如：KP1024）"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货联系人" required>
          <el-input
            v-model="address.mdbcej4opshigmrs"
            placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" required>
          <el-input
            v-model="address.xejhteu0ub3fd3eh"
            placeholder="请输入手机号码或固定电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地区" required>
          <el-cascader
            v-model="address.b3ccmzbfyzlwy9sc"
            :options="city"
            :props="props"
            placeholder="请选择省 / 市 / 区"
            class="full-width-cascader"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" required>
          <el-input
            placeholder="请输入楼栋、楼层、科室或具体库房门牌号"
            v-model="address['9simp0sjii9s0m33']"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="addAddress()" size="medium">保 存 地 址</el-button>
      </span>
    </el-dialog>

    <!-- 6. 微信支付弹窗组件 (保持原有机制) -->
    <wxPay ref="wxPay" @wxPaySuccess="submitAnOrder" :pay_amount="pay_amount" />
  </div>
</template>

<script>
import { online, relationFieldButtonExc, postOnline } from "@/api/platform";
import city from "@/util/city";
import wxPay from "@/components/wxPay.vue";
import Big from "big.js";

export default {
  name: "CreateOrder",
  data () {
    return {
      form: "",
      addressList: [],
      id: "",
      remark: "",
      dialogVisible: false,
      address: {},
      city,
      props: {
        label: "name",
        value: "id",
      },
    };
  },
  components: {
    wxPay,
  },
  created () {
    this.form = this.$route.query.form;
  },
  computed: {
    commodityList () {
      return this.$store.state.commodityList || [];
    },
    number () {
      return this.$store.state.number || 1;
    },
    pay_amount () {
      let money = 0;
      this.commodityList.forEach((el) => {
        // 购物车
        if (this.form === "cart") {
          let num = new Big(+el.tbdn8rpen3ijbiv2)
            .times(+el.qajsmihzqxevgihj)
            .toString();
          money = new Big(money).plus(+num).toString();
        } else if (this.form === "regularPurchaseList") {
          let num = new Big(+el.mcuilzaudpe3shlc)
            .times(+el.t9rtdu9o7iztvayy)
            .toString();
          money = new Big(money).plus(+num).toString();
        } else {
          let num = new Big(+this.number)
            .times(+el.f93blbqlvdtdt65v)
            .toString();
          money = new Big(money).plus(+num).toString();
        }
      });
      return +money;
    },
  },
  mounted () {
    this.getAddressList();
  },
  methods: {
    formatMoney (val) {
      if (val === null || val === undefined || val === '') return '0.00';
      const num = Number(val);
      return Number.isFinite(num) ? num.toFixed(2) : String(val);
    },
    showDialogVisible () {
      this.dialogVisible = true;
      this.address = {};
    },
    async addAddress () {
      const { address } = this;
      const validations = [
        { field: "3ulvzh2pgygl0vga", error: "请输入工号" },
        { field: "mdbcej4opshigmrs", error: "请输入联系人" },
        { field: "xejhteu0ub3fd3eh", error: "请输入联系电话" },
        { field: "b3ccmzbfyzlwy9sc", error: "请选择所在地区" },
        { field: "9simp0sjii9s0m33", error: "请输入详细地址" },
      ];
      for (const { field, error } of validations) {
        if (!address[field]) {
          return this.$notify.error({ title: "提示", message: error });
        }
      }
      await postOnline({
        ...address,
        form_head_uuid: "0f5b2fde26c04882a5d6c5c885a30a3f",
      });
      this.$notify({
        title: "提示",
        message: "新增成功",
        type: "success",
      });
      this.dialogVisible = false;
      this.getAddressList();
    },
    async getAddressList () {
      try {
        const { result } = await online({
          page: 1,
          limit: 100,
          keyword: "",
          select_option: "",
          form_head_uuid: "0f5b2fde26c04882a5d6c5c885a30a3f",
        });
        this.addressList = result || [];
        if (this.addressList.length > 0 && !this.id) {
          this.id = this.addressList[0].id;
        }
      } catch (error) {
        this.addressList = [];
      }
    },
    changeAddress ({ id }) {
      this.id = id;
    },
    // 微信支付
    handleWechatPay () {
      const { id } = this;
      if (!id) {
        return this.$notify({
          title: "提示",
          message: "请选择收货地址",
          type: "error",
        });
      }
      this.$refs.wxPay.dialogVisible = true;
    },
    // 提交订单
    createAnOrder () {
      const { id } = this;
      if (!id) {
        return this.$notify({
          title: "提示",
          message: "请选择收货地址",
          type: "error",
        });
      }
      this.submitAnOrder();
    },
    async submitAnOrder () {
      const { number, id, commodityList, form } = this;
      let button_uuid = "";
      let data = {};
      let form_head_uuid = "";
      if (form === "cart") {
        button_uuid = "625ddf61-caae-411f-8377-e40ef0976d4f";
        data = {
          ipfqvqscdmxi9c2j: id,
          lmwc6txhr0ens39w: +new Date(),
          fdaj8h2d6vindtaa: this.remark,
        };
        form_head_uuid = "a6cf518450fb43289af179b8beb4b943";
      } else if (form === "regularPurchaseList") {
        data = {
          biclfhzhbnslrm0a: id,
          on1ursdhpyrlbgs6: +new Date(),
          s3o1qgwo7qj43gt6: this.remark,
        };
        button_uuid = "ef5e158f-4c8b-43af-a3ea-441fbed26911";
        form_head_uuid = "d8334de005c511efb0750242321230b4";
      } else {
        button_uuid = "d8119e52-097d-4bfb-8849-d50c09e7b8cf";
        form_head_uuid = "1906dfc5e0ce4e7cb7d6324b06e6d470";
        data = {
          cta4eumu8zrwzabn: number,
          q34wefmlbegp0lth: id,
          otnacdfn3mngpxl8: this.remark,
        };
      }
      try {
        const categoryMap = commodityList.reduce((map, item) => {
          let tags = [];
          if (form === "regularPurchaseList") {
            tags = item.akwtnsppfazxxhpt || [];
          } else if (form === 'cart') {
            tags = item.ssjszickckaymdja || [];
          } else {
            tags = item.dzornqdwofgytboq || [];
          }
          const categoryId = tags.length > 0 ? tags[0].id : "未分类";
          if (!map[categoryId]) {
            map[categoryId] = [];
          }
          map[categoryId].push(item);
          return map;
        }, {});

        const categoryGroups = Object.entries(categoryMap).map(
          ([categoryId, items]) => ({
            categoryId,
            items,
          })
        );

        const loadingInstance = this.$loading({
          lock: true,
          text: "正在提交企业采购订单...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        try {
          for (let i = 0; i < categoryGroups.length; i++) {
            const group = categoryGroups[i];
            try {
              loadingInstance.text = `正在提交第 ${i + 1}/${categoryGroups.length} 个分类的订单...`;
              if (form === "cart") {
                data.lmwc6txhr0ens39w = +new Date();
              } else if (form === "regularPurchaseList") {
                data.on1ursdhpyrlbgs6 = +new Date();
              }
              await relationFieldButtonExc({
                button_uuid,
                data,
                form_head_uuid,
                ids: group.items.map((item) => item.id),
              });

              if (i < categoryGroups.length - 1) {
                await new Promise((resolve) => setTimeout(resolve, 3000));
              }
            } catch (error) {
              console.error(`分类 ${group.categoryId} 订单提交失败:`, error);
              throw error;
            }
          }

          loadingInstance.close();
          this.$notify({
            title: "下单成功",
            message: "采购订单已提交成功，正在流转审核与对账",
            type: "success",
          });

          await this.$store.dispatch("getCartQuantity");

          setTimeout(() => {
            this.$router.replace("/mall/show/index");
          }, 1800);
        } catch (error) {
          loadingInstance.close();
          throw error;
        }
      } catch (error) {
        console.error("订单提交失败:", error);
        this.$notify({
          title: "错误",
          message: "提交订单失败，请检查网络或重试",
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var.less';

.CreateOrder {
  padding: 16px 0 60px;

  // 1. 顶部步骤条
  .order-step-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 10px;
    padding: 20px 40px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 40, 100, 0.03);

    .step-item {
      display: flex;
      align-items: center;
      gap: 10px;

      .step-num {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background-color: #f1f5f9;
        color: #94a3b8;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: 700;
      }

      .step-title {
        font-size: 14px;
        color: @brandTextLight;
        font-weight: 500;
      }

      &.is-finish {
        .step-num {
          background-color: #ecfdf5;
          color: #059669;
        }
        .step-title {
          color: #059669;
        }
      }

      &.is-active {
        .step-num {
          background-color: @brandPrimary;
          color: #ffffff;
          box-shadow: 0 2px 6px rgba(15, 82, 186, 0.3);
        }
        .step-title {
          color: @brandPrimary;
          font-weight: 700;
        }
      }
    }

    .step-line {
      flex: 1;
      max-width: 140px;
      height: 2px;
      background-color: #e2e8f0;
      margin: 0 16px;

      &.is-finish {
        background-color: #a7f3d0;
      }
    }
  }

  // 通用卡片容器
  .section-card {
    background-color: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 40, 100, 0.03);

    .section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f1f5f9;

      .header-left {
        display: flex;
        align-items: center;
        gap: 8px;

        .accent-bar {
          width: 3px;
          height: 16px;
          background-color: @brandPrimary;
          border-radius: 2px;
        }

        .section-title {
          font-size: 16px;
          font-weight: 700;
          color: @brandTextDark;
          margin: 0;
        }

        .section-sub {
          font-size: 12px;
          color: @brandTextLight;
        }
      }

      .add-address-btn {
        background: none;
        border: 1px solid @brandPrimary;
        color: @brandPrimary;
        padding: 5px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 4px;
        transition: all 0.15s ease;

        &:hover {
          background-color: #f0f5ff;
        }
      }

      .contract-tax-tag {
        font-size: 12px;
        color: #10b981;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 4px;
      }
    }
  }

  // 2. 收货地址网格
  .address-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    .address-card {
      position: relative;
      background-color: #f8fafc;
      border: 1.5px solid #e2e8f0;
      border-radius: 10px;
      padding: 18px 16px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      gap: 8px;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      box-sizing: border-box;

      &:hover {
        border-color: #94a3b8;
        background-color: #ffffff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      }

      &.is-selected {
        background-color: #f0f5ff;
        border-color: @brandPrimary;
        box-shadow: 0 4px 16px rgba(15, 82, 186, 0.12);

        .selected-corner {
          position: absolute;
          top: 0;
          right: 0;
          width: 0;
          height: 0;
          border-top: 28px solid @brandPrimary;
          border-left: 28px solid transparent;
          border-top-right-radius: 8px;

          i {
            position: absolute;
            top: -26px;
            right: 2px;
            color: #ffffff;
            font-size: 11px;
            font-weight: bold;
          }
        }
      }

      .card-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2px;

        .receiver-name {
          font-size: 14px;
          font-weight: 700;
          color: @brandTextDark;
        }

        .badge-empid {
          font-size: 11px;
          color: @brandPrimary;
          background-color: rgba(15, 82, 186, 0.08);
          padding: 1px 6px;
          border-radius: 4px;
          font-weight: 500;
        }
      }

      .card-detail-item {
        display: flex;
        align-items: flex-start;
        gap: 6px;
        font-size: 12px;
        color: @brandTextLight;
        line-height: 1.5;

        .item-icon {
          color: #94a3b8;
          margin-top: 2px;
          flex-shrink: 0;
        }

        &.addr-text {
          min-height: 36px;
          color: @brandTextDark;
        }
      }

      &.add-card {
        border: 1.5px dashed #cbd5e1;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          border-color: @brandPrimary;
          background-color: #f0f5ff;

          .add-icon-circle {
            background-color: @brandPrimary;
            color: #ffffff;
          }
          .add-text {
            color: @brandPrimary;
          }
        }

        .add-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;

          .add-icon-circle {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background-color: #f1f5f9;
            color: #94a3b8;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            transition: all 0.15s ease;
          }

          .add-text {
            font-size: 13px;
            font-weight: 600;
            color: @brandTextLight;
            transition: color 0.15s ease;
          }
        }
      }
    }
  }

  // 3. 物料表格
  .goods-table-header {
    display: flex;
    align-items: center;
    height: 42px;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    color: @brandTextLight;
    padding: 0 16px;

    .col-info { flex: 1; min-width: 360px; }
    .col-price { width: 140px; text-align: center; }
    .col-unit { width: 100px; text-align: center; }
    .col-qty { width: 120px; text-align: center; }
    .col-total { width: 140px; text-align: right; }
  }

  .goods-row-list {
    list-style: none;
    padding: 0;
    margin: 8px 0 0;

    .goods-table-row {
      display: flex;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f1f5f9;
      transition: background-color 0.15s ease;

      &:hover {
        background-color: #f8fafc;
      }

      .col-info {
        flex: 1;
        min-width: 360px;
        display: flex;
        align-items: center;
        gap: 14px;

        .thumb-wrap {
          width: 64px;
          height: 64px;
          background-color: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 4px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;

          .thumb-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            mix-blend-mode: multiply;
          }
        }

        .meta-info {
          display: flex;
          flex-direction: column;
          gap: 4px;

          .name-text {
            font-size: 13px;
            font-weight: 600;
            color: @brandTextDark;
            line-height: 1.4;
            margin: 0;
          }

          .sku-code {
            font-size: 11px;
            color: @brandTextLight;
            background-color: #f1f5f9;
            padding: 1px 6px;
            border-radius: 4px;
            align-self: flex-start;
          }
        }
      }

      .col-price {
        width: 140px;
        text-align: center;
        font-size: 14px;
        color: @brandTextDark;
        font-weight: 500;
      }

      .col-unit {
        width: 100px;
        text-align: center;
        font-size: 13px;
        color: @brandTextLight;
      }

      .col-qty {
        width: 120px;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: @brandTextDark;
      }

      .col-total {
        width: 140px;
        text-align: right;
        font-size: 15px;
        font-weight: 700;
        color: @brandPrimary;
      }
    }
  }

  // 4. 结算看板双栏
  .settle-dashboard-layout {
    display: grid;
    grid-template-columns: 1fr 420px;
    gap: 20px;
    align-items: start;

    .remark-card {
      .remark-textarea {
        /deep/ .el-textarea__inner {
          border-radius: 8px;
          border-color: #cbd5e1;
          font-size: 13px;
          padding: 12px;

          &:focus {
            border-color: @brandPrimary;
          }
        }
      }

      .remark-tips {
        margin-top: 10px;
        font-size: 12px;
        color: #94a3b8;
        display: flex;
        align-items: center;
        gap: 4px;
      }
    }

    .summary-card {
      background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);

      .summary-lines {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .summary-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 13px;

          .label {
            color: @brandTextLight;
          }

          .val {
            color: @brandTextDark;
            font-weight: 600;

            &.free-tag {
              color: #10b981;
            }
          }

          &.total-row {
            margin-top: 4px;
            align-items: baseline;

            .total-label {
              font-size: 15px;
              font-weight: 700;
              color: @brandTextDark;
            }

            .total-amount-box {
              display: flex;
              align-items: baseline;
              color: @brandPrimary;

              .currency {
                font-size: 18px;
                font-weight: 700;
                margin-right: 2px;
              }

              .total-amount {
                font-size: 30px;
                font-weight: 800;
                letter-spacing: -0.5px;
              }
            }
          }
        }

        .summary-divider {
          height: 1px;
          background-color: #e2e8f0;
          margin: 6px 0;
        }
      }

      .action-buttons-wrap {
        display: flex;
        gap: 12px;
        margin-top: 24px;

        .pay-btn {
          flex: 1;
          height: 46px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          box-sizing: border-box;

          &.wechat-btn {
            background-color: #07c160;
            border: 1px solid #07c160;
            color: #ffffff;
            box-shadow: 0 4px 12px rgba(7, 193, 96, 0.2);

            &:hover {
              background-color: #06ad56;
              transform: translateY(-1px);
            }
          }

          &.submit-btn {
            background-color: @brandPrimary;
            border: 1px solid @brandPrimary;
            color: #ffffff;
            box-shadow: 0 4px 14px rgba(15, 82, 186, 0.25);

            &:hover {
              background-color: @brandContainer;
              border-color: @brandContainer;
              transform: translateY(-1px);
              box-shadow: 0 6px 18px rgba(15, 82, 186, 0.35);
            }
          }
        }
      }

      .safe-promise-text {
        margin: 14px 0 0;
        font-size: 11px;
        color: #94a3b8;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }
    }
  }
}

// 地址弹窗规范
.address-dialog {
  /deep/ .el-dialog {
    border-radius: 12px;
    overflow: hidden;
  }

  /deep/ .el-dialog__header {
    background-color: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    padding: 16px 20px;

    .el-dialog__title {
      font-size: 15px;
      font-weight: 700;
      color: @brandTextDark;
    }
  }

  .dialog-form {
    padding: 10px 10px 0 0;

    .full-width-cascader {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/CreateOrder.vue